import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { PageLoader } from '../../../../../../Common/Components/PageLoader';
import moment from 'moment';
import {numberWithCommas} from '../../../../../../../Utils/NumberToComma';
import { PDFExport } from '@progress/kendo-react-pdf';
import { useReactToPrint } from 'react-to-print';
import PiaLogo from './PiaLogo.png';
import InmLogo from './InmLogo.png';
import AwaLogo from './AwaLogo.png';
import AfhLogo from './AfhLogo.png';
import FouLogo from './FouLogo.png';
import inrInWords from '../../../../../../../Utils/INRToWords';

function Ask({ data, defaultBank }) {
  if (!data) return <PageLoader />;
  const pdf = useRef(null);

  let totalBaseAmount = 0;
  let totalTax = 0;
  let grandTotal = 0;
  let cgstIgstShow =
    data.billingTo.gstin[0] + data.billingTo.gstin[1] ===
    data.vendor.gstin[0] + data.vendor.gstin[1]
      ? true
      : false;

  data.procured.forEach((val) => {
    totalBaseAmount += val.base;
    totalTax += val.tax;
    grandTotal += val.amount;
  });

  const printForm = useReactToPrint({
    content: () => pdf.current,
    documentTitle: data.orderId,
  });

const styles = {
    container: {
      fontFamily: "Arial, sans-serif",
      maxWidth: 900,
      margin: "0px auto",
      background: "#fff",
      padding: 14,
      fontSize: 14,
      color: "#222",
      boxShadow: "0 2px 8px #eee",
    },
    header: {
      display: "flex",
      justifyContent: 'end',
      marginBottom: 16,
    },
    logo: {
      height: 45,
    },
    title: {
      fontWeight: "bold",
      fontSize: 18,
      textAlign: "center",
      margin: "16px 0 8px 0",
      letterSpacing: 1,
    },
    section: {
      margin: "12px 0",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      margin: "12px 0",
    },
    th: {
      border: "1px solid #000",
      background: "#f5f5f5",
      padding: "6px 8px",
      fontWeight: "bold",
      textAlign: "center",
    },
    td: {
      border: "1px solid #000",
      padding: "6px 8px",
      verticalAlign: "top",
    },
    right: {
      textAlign: "right",
    },
    bold: {
      fontWeight: "bold",
    },
    small: {
      fontSize: 12,
      color: "#555",
    },
    signature: {
      height: 60,
      margin: "8px 0",
    },
    note: {
      fontSize: 12,
      marginTop: 12,
      color: "#333",
    },
  };

return (
  <div style={styles.container}>
    <div style={{ textAlign: "right" }}>
      <p
        style={{
          fontWeight: 600,
          color: "var(--primary-color)",
          cursor: "pointer",
          marginBottom: "10px",
        }}
        onClick={() => {
          printForm();
        }}
      >
        Print
      </p>
    </div>
    <PDFExport
      paperSize="A4"
      title="Order Document"
      padding="50"
      fileName={`Order-${data.orderId}.pdf`}
      ref={(r) => (pdf.current = r)}
    >
      {/* Header */}
      <div style={{padding:'50px'}}>
      <div style={styles.header}>
        <div>
          <div style={{ ...styles.bold, fontSize: 16}}>
            {
                data.billingTo.entityName.includes('PIA') && <img
                src={PiaLogo}
                alt="ASK Group Logo"
                style={styles.logo}
              />
            }
            {
                data.billingTo.entityName.includes('INM') && <img
                src={InmLogo}
                alt="ASK Group Logo"
                style={styles.logo}
              />
            }
            {
                data.billingTo.entityName.includes('AWA') && <img
                src={AwaLogo}
                alt="ASK Group Logo"
                style={styles.logo}
              />
            }
            {
                data.billingTo.entityName.includes('AFH') && <img
                src={AfhLogo}
                alt="ASK Group Logo"
                style={styles.logo}
              />
            }
            {
                data.billingTo.entityName.includes('FOU') && <img
                src={FouLogo}
                alt="ASK Group Logo"
                style={styles.logo}
              />
            }
            {
                data.billingTo.entityName.includes('IBR') && <img
                src={InmLogo}
                alt="ASK Group Logo"
                style={styles.logo}
              />
            }
            {
                data.billingTo.entityName.includes('LFS') && <img
                src={InmLogo}
                alt="ASK Group Logo"
                style={styles.logo}
              />
            }
            {
                data.billingTo.entityName.includes('TRU') && <img
                src={InmLogo}
                alt="ASK Group Logo"
                style={styles.logo}
              />
            }
          </div>
        </div>
      </div>

      {/* Billing Details Table */}
      <div style={styles.section}>
        <table style={styles.table}>
          <thead>
            <tr>
              <td
                colSpan={6}
                style={{
                  ...styles.td,
                  ...styles.bold,
                  textDecoration: "underline",
                  fontSize: 16,
                }}
              >
                Purchase order
              </td>
            </tr>
            <tr>
              <td colSpan={6} style={{ ...styles.td, ...styles.bold }}>
                {data.billingTo.entityName}
              </td>
            </tr>
            <tr>
              <td colSpan={6} style={{ ...styles.td }}>
                <span>PO No.:</span> {data.orderId}
              </td>
            </tr>
            <tr>
                <td colSpan={6} style={{ ...styles.td }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", height: "100%" }}>
                        <p style={{ margin: 0, ...styles.bold, textAlign: "left" }}>
                        {data.vendor.name}
                        </p>
                        <p style={{ margin: 0, ...styles.bold, textAlign: "right" }}>
                        Date: {moment(data.details.createdAt).format("DD-MMM-YYYY")}
                        </p>
                    </div>
                </td>
            </tr>
            <tr>
              <td colSpan={6} style={{ textAlign: "left", ...styles.td }}>
                <p style={{ width: "50%" }}>{data.vendor.address.address}</p>
                <p>GSTIN : {data.vendor.gstin}</p>
              </td>
            </tr>
            <tr>
              <td colSpan={6} style={{ ...styles.td, ...styles.bold }}>
                {data.title}
              </td>
            </tr>
            <tr><td colSpan={6} style={styles.td}></td></tr>
            <tr>
              <th style={styles.th}>Description</th>
              <th style={styles.th}>Qty</th>
              <th style={styles.th}>Rate</th>
              <th style={styles.th}>Tax</th>
              <th style={styles.th}>Tax Percentage</th>
              <th style={styles.th}>Amount</th>
            </tr>
            {data.procured.map((item, index) => (
              <tr key={index}>
                <td style={{textAlign:'left',...styles.td}}>{item.description}</td>
                <td style={styles.td}>{item.qtty}</td>
                <td style={styles.td}>{numberWithCommas(item.price)}</td>
                <td style={styles.td}>{item.tax}</td>
                <td style={styles.td}>{item.taxSlab}%</td>
                <td style={{textAlign:'right',...styles.td}}>{numberWithCommas(item.base)}</td>
              </tr>
            ))}
            <tr>
              <td
                colSpan={5}
                style={{ ...styles.td, ...styles.right, ...styles.td, ...styles.bold }}
              >
                Total
              </td>
              <td style={{textAlign:'right',...styles.td}}>{numberWithCommas(totalBaseAmount)}</td>
            </tr>
            <tr>
              <td
                colSpan={5}
                style={{ ...styles.td, ...styles.right, ...styles.td }}
              >
                CGST
              </td>
              <td style={{textAlign:'right',...styles.td}}>
                {cgstIgstShow ? parseFloat(totalTax / 2.0) : 0.0}
              </td>
            </tr>
            <tr>
              <td
                colSpan={5}
                style={{ ...styles.td, ...styles.right, ...styles.td }}
              >
                SGST
              </td>
              <td style={{textAlign:'right',...styles.td}}>
                {cgstIgstShow ? parseFloat(totalTax / 2.0) : 0.0}
              </td>
            </tr>
            <tr>
              <td
                colSpan={5}
                style={{ ...styles.td, ...styles.right, ...styles.td }}
              >
                IGST
              </td>
              <td style={{textAlign:'right',...styles.td}}>
                {cgstIgstShow ? 0.0 : parseFloat(totalTax)}
              </td>
            </tr>
            <tr>
              <td
                colSpan={5}
                style={{
                  ...styles.td,
                  ...styles.right,
                  ...styles.bold,
                  ...styles.td,
                }}
              >
                Grand Total
              </td>
              <td style={{ ...styles.td, ...styles.bold, textAlign: "right" }}>
                {numberWithCommas(grandTotal)}
              </td>
            </tr>
            <tr>
              <td
                colSpan={6}
                style={{
                  ...styles.td,
                  ...styles.bold,
                  ...styles.td,
                  textAlign: "center",
                }}
              >
                Grand Total (In Words) :- {inrInWords(grandTotal)}
              </td>
            </tr>
            <tr>
              <td style={{ ...styles.bold, ...styles.td, width: "50%",textAlign: "left" }}>
                Place of Delivery & Installation
              </td>
              <td colSpan={5} style={styles.td}>
                <p style={{ textAlign: "left", ...styles.bold }}>
                  {data.billingTo.entityName}
                </p>
                <br />
                <p style={{ textAlign: "left" }}> {data.billingTo.address}</p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ ...styles.td, ...styles.bold,textAlign:'left' }}>Payment term:</td>
              <td colSpan={5} style={styles.td}>
                {data.payments.map((payment, index) => {
                  return (
                    <p key={index} style={{ textAlign: "left" }}>
                      {index}
                      {payment.title} :- {payment.description}
                    </p>
                  );
                })}
              </td>
            </tr>
            <tr>
              <td style={{ ...styles.td, ...styles.bold,textAlign:'left' }}>
                Other terms & conditions:
              </td>
              <td colSpan={5} style={styles.td}>
                {data.conditions.map((condition, index) => {
                  return (
                    <p key={index} style={{ textAlign: "left",...styles.bold }}>
                      {index}
                      {condition.title} :- {condition.description}
                    </p>
                  );
                })}
              </td>
            </tr>
            <tr>
              <td style={{ ...styles.td, ...styles.bold,textAlign:'left' }}>
                Prepared by: {data.adminName}
              </td>
              <td colSpan={5} style={{ ...styles.td, ...styles.bold,textAlign:'left' }}>
                Date: {moment(data.details.createdAt).format("DD-MMM-YYYY")}
              </td>
            </tr>
            <tr>
              <td colSpan={6} style={styles.td}></td>
            </tr>
            <tr>
              <td colSpan={6} style={styles.td}>
                <p style={{ textAlign: "left" }}>
                  Note: Pls. Sign and return a copy of the order, as token of
                  acceptance
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <div
        style={{
          ...styles.small,
          marginTop: 24,
          borderTop: "1px solid #ccc",
          paddingTop: 8,
          paddingBottom: 16,
        }}
      >
        <b>{data.billingTo.entityName}</b><br/> Regd. Office: {data.billingTo.entityRegisteredAddress}
        <br />
        <br />T { data.billingTo.entityTags && data.billingTo.entityTags.telephone_num ? data.billingTo.entityTags.telephone_num : '+91 22 6652 0000'} | F {(data.billingTo.entityTags && data.billingTo.entityTags.fax_num ? data.billingTo.entityTags.fax_num :'+91 22 2432 5620')} |  
        {(data.billingTo.entityTags && data.billingTo.entityTags.website ? data.billingTo.entityTags.website :'www.askinvestmentmanagers.com')} | CIN No. {(data.billingTo.entityTags && data.billingTo.entityTags.CIN ? data.billingTo.entityTags.CIN :'U65993MH2004PLC147890')}
      </div>
      <strong style={{ float: "right",marginTop:16}}>This is system generated copy, signature is not required.</strong>
      </div>
    </PDFExport>
  </div>
);
}

export default connect((state) => ({ config: state.auth.config }))(Ask);